import { render, staticRenderFns } from "./GameMaster.vue?vue&type=template&id=1b5e3932&scoped=true&"
import script from "./GameMaster.vue?vue&type=script&lang=ts&"
export * from "./GameMaster.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5e3932",
  null
  
)

export default component.exports